// Sur téléphone et tablette, le résumé d'une ligne choisie s'affiche sous la liste : on l'amène à l'écran
// après le choix, pour que l'effet du geste soit visible. Sur ordinateur, il est déjà à côté du tableau.

export function montrerSurPetitEcran(idTitre: string): void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
  if (!window.matchMedia('(max-width: 1000px)').matches) return;
  window.requestAnimationFrame(() => {
    const cible = document.getElementById(idTitre);
    if (!cible) return;
    const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    cible.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'start' });
  });
}
